import type { Event } from '@patsnap/tahiti-core/common/event';
import type { SupportedSide, DualViewRefItem, DualViewRef } from '../types';

export const DualViewRefService = Symbol.for('DualViewRefService');

export interface DualViewRefService {
    readonly onStatesChange: Event<DualViewRef>;

    leftRef: DualViewRefItem;
    rightRef: DualViewRefItem;

    getModelData(): DualViewRef;
    updateRefBySide(target: { side: SupportedSide, ref: DualViewRefItem }): void;
    clearRefBySide(target: { side: SupportedSide }): void;
}
